import { type PropsWithChildren, type ReactNode, type Ref, type SyntheticEvent, forwardRef } from 'react';

import styles from './GalleryActions.css';

export function GalleryActions({ children, ref }: PropsWithChildren<{ ref?: Ref<HTMLUListElement> }>): ReactNode {
  return (
    <ul className={styles['actions-list']} ref={ref}>
      {children}
    </ul>
  );
}

GalleryActions.Item = function GalleryActionsItem({
  children,
  onClick,
}: PropsWithChildren<{ onClick: (e: SyntheticEvent) => void }>): ReactNode {
  return (
    <li className={styles['action-item']}>
      <button className={styles['action-item-button']} onClick={onClick}>
        {children}
      </button>
    </li>
  );
};

GalleryActions.Dropdown = forwardRef(function GalleryActionsDropdown(
  { children }: PropsWithChildren,
  ref: Ref<HTMLDivElement>,
): ReactNode {
  return (
    <div className={styles['dropdown']} ref={ref}>
      {children}
    </div>
  );
});

GalleryActions.Buttons = function GalleryActionsButtons({ children }: PropsWithChildren): ReactNode {
  return <div className={styles['buttons']}>{children}</div>;
};
